import { Routes } from "@angular/router";
import { AuthShellLayout } from "./Common/Layout/Auth/AuthShellLayout";
import { PublicShellLayout } from "./Common/Layout/Public/PublicShellLayout";
import { LoginPage } from "./Modules/Auth/Pages/Login/LoginPage";
import { ResetPasswordPage } from "./Modules/Auth/Pages/ResetPassword/ResetPasswordPage";
import { ForbiddenPage } from "./Modules/Error/Forbidden/ForbiddenPage";
import { NotFoundPage } from "./Modules/Error/NotFound/NotfoundPage";
import { HomePage } from "./Modules/Dashboard/Pages/Home/HomePage";
import { DesignPage } from "./Modules/Dashboard/Pages/Design/DesignPage";
import { UserHomePage } from "./Modules/User/Pages/Home/UserHomePage";
import { UserCreatePage } from "./Modules/User/Pages/Create/UserCreatePage";
import { UserEditPage } from "./Modules/User/Pages/Edit/UserEditPage";
import { UserProfilePage } from "./Modules/User/Pages/Profile/UserProfilePage";
import { RoleHomePage } from "./Modules/Role/Pages/Home/RoleHomePage";
import { RoleEditPage } from "./Modules/Role/Pages/Edit/RoleEditPage";
import { RoleCreatePage } from "./Modules/Role/Pages/Create/RoleCreatePage";
import { FileHomePage } from "./Modules/File/Pages/Home/FileHomePage";
import { TestTablePage } from "./Modules/Dashboard/Pages/TestTable/TestTablePage";
import { SessionHomePage } from "./Modules/Session/Pages/Home/SessionHomePage";
import { AuditHomePage } from "./Modules/Audit/Pages/Home/AuditHomePage";
import { AuditViewPage } from "./Modules/Audit/Pages/View/AuditViewPage";
import { authGuard } from "./Modules/Auth/Guard/AuthGuard";
import { PartnerHomePage } from "./Modules/Partner/Pages/Home/PartnerHomePage";
import { PartnerCreatePage } from "./Modules/Partner/Pages/Create/PartnerCreatePage";
import { PartnerEditPage } from "./Modules/Partner/Pages/Edit/PartnerEditPage";
import { TeamLeaderHomePage } from "./Modules/TeamLeader/Pages/Home/TeamLeaderHomePage";
import { TeamLeaderEditPage } from "./Modules/TeamLeader/Pages/Edit/TeamLeaderEditPage";
import { TeamLeaderCreatePage } from "./Modules/TeamLeader/Pages/Create/TeamLeaderCreatePage";
import { MaterialHomePage } from "./Modules/Material/Pages/Home/MaterialHomePage";
import { MaterialCreatePage } from "./Modules/Material/Pages/Create/MaterialCreatePage";
import { MaterialEditPage } from "./Modules/Material/Pages/Edit/MaterialEditPage";
import { WarehouseHomePage } from "./Modules/Warehouse/Pages/Home/WarehouseHomePage";
import { WarehouseCreatePage } from "./Modules/Warehouse/Pages/Create/WarehouseCreatePage";
import { WarehouseEditPage } from "./Modules/Warehouse/Pages/Edit/WarehouseEditPage";
import { StockHomePage } from "./Modules/Stock/Pages/Home/StockHomePage";
import { StockAdjustmentCreatePage } from "./Modules/Stock/Pages/Create/StockInitialAdjustmentCreatePage";
import { StockDetailPage } from "./Modules/Stock/Pages/Detail/StockDetailPage";
import { RequestHomePage } from "./Modules/Request/Pages/Home/RequestHomePage";
import { RequestCreatePage } from "./Modules/Request/Pages/Create/RequestCreatePage";
import { RequestEditPage } from "./Modules/Request/Pages/Edit/RequestEditPage";
import { VendorHomePage } from "./Modules/Vendor/Pages/Home/VendorHomePage";
import { VendorCreatePage } from "./Modules/Vendor/Pages/Create/VendorCreatePage";
import { VendorEditPage } from "./Modules/Vendor/Pages/Edit/VendorEditPage";
import { PrintingHomePage } from "./Modules/Printing/Pages/Home/PrintingHomePage";
import { PrintingCreatePage } from "./Modules/Printing/Pages/Create/PrintingCreatePage";
import { PrintingEditPage } from "./Modules/Printing/Pages/Edit/PrintingEditPage";
import { ShipmentHomePage } from "./Modules/Shipment/Pages/Home/ShipmentHomePage";
import { ShipmentCreatePage } from "./Modules/Shipment/Pages/Create/ShipmentCreatePage";
import { ShipmentEditPage } from "./Modules/Shipment/Pages/Edit/ShipmentEditPage";
import { TestimonyHomePage } from "./Modules/Testimony/Pages/Home/TestimonyHomePage";
import { TestimonyEditPage } from "./Modules/Testimony/Pages/Edit/TestimonyEditPage";
import { PartnerPublicRequestPage } from "./Modules/Partner/Pages/PublicRequest/PartnerPublicRequestPage";

export const routes: Routes = [
  {
    path: "",
    component: PublicShellLayout,
    children: [
      { path: "login", component: LoginPage },
      { path: "reset-password", component: ResetPasswordPage },
      { path: "public/request/:token", component: PartnerPublicRequestPage },
      { path: "design", component: DesignPage },
      { path: "", pathMatch: "full", redirectTo: "login" },
    ],
  },
  {
    path: "",
    component: AuthShellLayout,
    canActivateChild: [authGuard],
    children: [
      { path: "403", component: ForbiddenPage },
      { path: "forbidden", component: ForbiddenPage },
      { path: "home", component: HomePage },
      { path: "partners", component: PartnerHomePage },
      { path: "partners/create", component: PartnerCreatePage },
      { path: "partners/edit/:id", component: PartnerEditPage },
      { path: "team-leaders", component: TeamLeaderHomePage },
      { path: "team-leaders/create", component: TeamLeaderCreatePage },
      { path: "team-leaders/edit/:id", component: TeamLeaderEditPage },
      { path: "users", component: UserHomePage },
      { path: "users/create", component: UserCreatePage },
      { path: "users/edit/:id", component: UserEditPage },
      { path: "profile", component: UserProfilePage },
      { path: "roles", component: RoleHomePage },
      { path: "roles/edit/:id", component: RoleEditPage },
      { path: "roles/create", component: RoleCreatePage },
      { path: "files", component: FileHomePage },
      { path: "sessions", component: SessionHomePage },
      { path: "audits", component: AuditHomePage },
      { path: "audits/view/:id", component: AuditViewPage },
      { path: "test-table", component: TestTablePage },
      { path: "materials", component: MaterialHomePage },
      { path: "materials/create", component: MaterialCreatePage },
      { path: "materials/edit/:id", component: MaterialEditPage },
      { path: "warehouses", component: WarehouseHomePage },
      { path: "warehouses/create", component: WarehouseCreatePage },
      { path: "warehouses/edit/:id", component: WarehouseEditPage },
      { path: "stocks", component: StockHomePage },
      { path: "stocks/adjustments/create", component: StockAdjustmentCreatePage },
      { path: "stocks/initial-adjustments/create", component: StockAdjustmentCreatePage },
      { path: "stocks/:id", component: StockDetailPage },
      { path: "requests", component: RequestHomePage },
      { path: "requests/create", component: RequestCreatePage },
      { path: "requests/edit/:id", component: RequestEditPage },
      { path: "shipments", component: ShipmentHomePage },
      { path: "shipments/create", component: ShipmentCreatePage },
      { path: "shipments/edit/:id", component: ShipmentEditPage },
      { path: "testimonies", component: TestimonyHomePage },
      { path: "testimonies/edit/:id", component: TestimonyEditPage },
      { path: "vendors", component: VendorHomePage },
      { path: "vendors/create", component: VendorCreatePage },
      { path: "vendors/edit/:id", component: VendorEditPage },
      { path: "printings", component: PrintingHomePage },
      { path: "printings/create", component: PrintingCreatePage },
      { path: "printings/edit/:id", component: PrintingEditPage },
    ],
  },
  { path: "**", component: NotFoundPage },
];
